import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { WEB_ROUTES } from '@portal-contract';
import { useSession } from '@/session/SessionProvider';
import { ErrorState, LoadingState } from '@/components/States';

/** Gate for every screen that needs a session. The first GET /api/me decides; no session goes to /login. */
export function RequireSession() {
  const { status, bootError, retryBoot } = useSession();
  const location = useLocation();
  if (status === 'loading') return <LoadingState rows={4} />;
  if (status === 'error') return <ErrorState error={bootError} onRetry={retryBoot} />;
  if (status === 'anonymous') {
    return <Navigate to={WEB_ROUTES.login} replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}
